import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchStudioMovies } from '../api/oplixi';

const SearchBar = () => {
  const [query, setQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setIsLoading(true);
    try {
      const results = await searchStudioMovies(query);
      // URL carries the query so results are shareable/refresh-safe; state
      // provides the instant first render.
      navigate(`/search?q=${encodeURIComponent(query)}`, {
        state: { results, query },
      });
    } catch (error) {
      // silently handle
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSearch} className="relative flex items-center">
      <div className={`flex items-center rounded-full transition-all duration-300 ${
        focused
          ? 'bg-white/15 ring-1 ring-white/30 w-full sm:w-72'
          : 'bg-white/10 w-full sm:w-56'
      }`}>
        {/* Search icon */}
        <button
          type="submit"
          className="pl-3.5 pr-1 py-2 text-gray-400 hover:text-white bg-transparent border-none flex-shrink-0"
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </button>
        <input
          type="text"
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          className="bg-transparent text-white text-sm pl-1 pr-3.5 py-2 w-full border-none focus:outline-none placeholder-gray-500"
          disabled={isLoading}
        />
      </div>
    </form>
  );
};

export default SearchBar;
